import {Accordion} from './accordion';
let accordion;

const initAccordion = () => {
  accordion = new Accordion();
};

export {initAccordion, accordion};
